import axios, { ticketingSysInstance } from 'util/axiosConfig';

// export const fetchTicketIdFromDb = (params) => {
//     let data = {
//       clientId: params.clientId,
//       visitNo: params.visitNo
//     }
//     return ticketingSysInstance
//       .post(`/ticket/fetch-ticketId`, {
//         data
//       })
//       .then(function (response) {
//         if (response.status == 200) {
//           return response.data;
//         }
//         return [];
//       })
//       .catch(function (error) {
//         return [];
//       });

//   }

export const fetchTicketDetailsFromDb = (params) => {
  let data = {
    clientId: params.clientId,
    ticketId: params.ticketId
  }
  return ticketingSysInstance
    .post(`/ticket/fetch-ticket-by-id`, {
      data
    })
    .then(function (response) {
      if (response.status == 200) {
        return response.data;
      }
      return [];
    })
    .catch(function (error) {
      return [];
    });

}

export const fetchCommentsFromDb = (params) => {
  let data = {
    clientId: params.clientId,
    ticketId: params.ticketId
  }
  return ticketingSysInstance
    .post(`/ticket/fetch-comments`, {
      data
    })
    .then(function (response) {
      if (response.status == 200) {
        return response.data;
      }
      return [];
    })
    .catch(function (error) {
      return [];
    });

}

export const addCommentToDb = (params) => {
  let data = {
    clientId: params.clientId,
    ticketId: params.ticketId,
    user: params.user,
    comment: params.comment,
    requester: true
  }
  return ticketingSysInstance
    .post(`/ticket/add-comment-without-auth`, {
      data
    })
    .then(function (response) {
      if (response.status == 200) {
        return response.data;
      }
      return [];
    })
    .catch(function (error) {
      return [];
    });

}

// export const fetchTicketIdFromDb = (params) => {
//   const array = params.visitNo.split("-");
//   const data = {
//     clientId: params.clientId,
//     visitNo: array[0],
//     reportId: params.reportId
//   }
//   return axios
//     .post(`/api/v1/ticket/fetch-ticketId`, data)
//     .then(function (response) {
//       if (response.status == 200) {
//         return response.data;
//       }
//       return [];
//     })
//     .catch(function (error) {
//       return [];
//     });

// }

// export const addTicketToDb = async (createTicketRequest) => {
//   return await axios.post(`/api/v1/ticket/create-ticket`, createTicketRequest)
//     .then(function (response) {
//       if (response.data) {
//         return { success: true, data: response.data };
//       } else {
//         return { success: false };
//       }
//     })
//     .catch(function (error) {
//       return { success: false, error };
//     });
// }

export const raiseTicketAPI = async (createTicketRequest) => {
  return await axios.post(`/api/v1/ticket/raise-ticket`, createTicketRequest)
    .then(function (response) {
      if (response.data) {
        return response.data.data;
      } else {
        return { success: false };
      }
    })
    .catch(function (error) {
      return { success: false, error };
    });
}

export const raiseSupportTicketAPI = async (createTicketRequest) => {
  return await axios.post(`/api/v1/ticket/raise`, createTicketRequest)
    .then(function (response) {
      if (response) {
        return { success: true };
      } else {
        return { success: false };
      }
    })
    .catch(function (error) {
      return { success: false, error };
    });
}